import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { rawColors } from "../../../design-system/tokens/colors";

/**
 * Outer card container — matches Figma `--stroke-200` border + 12px radius.
 */
export const Card = styled.section`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: ${spacing[4]};
  row-gap: ${spacing[3]};
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.primary};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
  padding: ${spacing[4]};
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
`;
